import { AboutIntro, HowWeWork, OutcomeFocus, StudioStory, Values } from "@/sections/AboutBlocks";
import { Process } from "@/sections/Process";
import { FinalCTA } from "@/sections/FinalCTA";

export default function AboutPage() {
  return (
    <main data-testid="about-page" className="pt-32 lg:pt-36">
      <AboutIntro />
      <StudioStory />
      <OutcomeFocus />
      <Values />
      <Process />
      <HowWeWork />
      <FinalCTA />
    </main>
  );
}
